import { ACCOUNT_STATUS } from '../constants/common.constant';
import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse, User } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const ACCOUNT_URL = '/ris/users/v1';

export interface ParamsGetAccount {
  created_at_from?: string;
  created_at_to?: string;
  creator_ids?: Array<string>;
  fullname?: string;
  group_id?: string;
  ids?: Array<string>;
  institutions?: Array<string>;
  limit?: number;
  offset?: number;
  roles?: Array<string>;
  sort_field?:
    | 'status'
    | 'username'
    | 'fullname'
    | 'title'
    | 'creator_id'
    | 'created_at'
    | 'updated_at';
  sort_order?: SORT_ORDER;
  statuses?: Array<ACCOUNT_STATUS>;
  title?: string;
  updated_at_from?: string;
  updated_at_to?: string;
  username?: string;
}
export interface ResponseGetAccount extends DefaultResponse {
  data: Omit<User, 'scopes' | 'signature'>[];
}
export const getAccounts = async (params: ParamsGetAccount) => {
  const response = (await api({
    url: ACCOUNT_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetAccount>;

  return response.data;
};

interface ResponseGetCurrentUser extends DefaultResponse {
  data: User;
}
export const getCurrentUser = async () => {
  const response = (await api({
    url: `${ACCOUNT_URL}/profile`,
    method: 'GET',
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetCurrentUser>;

  return response.data;
};

export interface ResponseGetAccountDetail extends DefaultResponse {
  data: User;
}
export const getDetailAccount = async (id: string) => {
  const response = (await api({
    url: `${ACCOUNT_URL}/${id}`,
    method: 'GET',
  })) as AxiosResponse<ResponseGetAccountDetail>;

  return response.data;
};

export interface ParamsCreateAccount {
  address?: string;
  birthdate?: string;
  email?: string;
  expired_at?: string;
  fullname: string;
  gender?: number;
  his_id?: string;
  institutions: string[];
  password: string;
  phone?: string;
  roles: string[];
  signature?: string;
  status?: number;
  title?: string;
  username: string;
}
export const createAccount = async (data: ParamsCreateAccount) => {
  const response = (await api({
    url: ACCOUNT_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateAccount {
  address: string;
  birthdate: string;
  default_institution_id: string;
  email: string;
  esign_code: string;
  esign_role: string;
  expired_at: string;
  fullname: string;
  gender: number;
  his_id: string;
  institutions: string[];
  password: string;
  phone: string;
  roles: string[];
  signature: string;
  status: number;
  title: string;
  username: string;
}
export const updateAccount = async (id: string, data: ParamsUpdateAccount) => {
  const response = (await api({
    url: `${ACCOUNT_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<
    DefaultResponse & {
      data: Omit<User, 'expired_at' | 'his_id' | 'is_super' | 'scopes'>;
    }
  >;

  return response.data;
};

export interface ParamsUpdateProfile {
  address?: string;
  birthdate?: string;
  default_institution_id?: string;
  email?: string;
  fullname?: string;
  gender?: number;
  his_id?: string;
  phone?: string;
  signature?: string;
  title?: string;
  username?: string;
}
export const updateProfile = async (id: string, data: ParamsUpdateProfile) => {
  const response = (await api({
    url: `${ACCOUNT_URL}/profile`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateSSOAccount {
  address: string;
  birthdate: string;
  email: string;
  fullname: string;
  gender: number;
  his_id: string;
  institutions: string[];
  phone: string;
  signature: string;
  title: string;
  username: string;
}
export const updateSSOAccount = async (
  id: string,
  data: ParamsUpdateSSOAccount
) => {
  const response = (await api({
    url: `${ACCOUNT_URL}/sso/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsChangePassword {
  password: string;
}
export const changePassword = async (data: ParamsChangePassword) => {
  const response = (await api({
    url: `${ACCOUNT_URL}/password`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export const deleteAccount = async (id: string) => {
  return (await api({
    url: `${ACCOUNT_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;
};
